import axios from 'axios';
import React, {useState, useEffect, useMemo, Fragment, useRef} from 'react';

import {FormControl, InputLabel, Input, FormHelperText, Alert, Stack} from '@mui/material';
import WebService from '@util/webService'
import {encodeParams, findCode, getAction, printVariable} from '@util/helper'
// redux
import {useSelector, useDispatch} from 'react-redux';
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import {useTable, useExpanded} from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { setSchola } from '@redux/actions/scholaAction';
import no_image from '@images/no_image.png'
import {
  Checkbox,
  FormGroup,
  FormControlLabel,
  Typography,
  Snackbar,
  TablePagination,
  TextField,
  withStyles,
  InputBase,
  Switch,
} from '@mui/material';
import {tablePaginationClasses} from '@mui/material/TablePagination'
import {styled, alpha} from '@mui/material/styles';
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton';
import useSnackbar from '@hooks/useSnackbar';
import MyTableHead from '@components/MyTableHead';
import useIndicator from '@hooks/useIndicator';
import Indicator from '@components/Indicator';
import MyDialog from '@components/MyDialog';
import useForm from '@hooks/useForm';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
// pagination
import {useTheme} from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

// date
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/ko';
import moment from 'moment';
import {
  Avatar,
  Grid,
  Container,
} from '@mui/material/';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import Autocomplete, {createFilterOptions} from '@mui/material/Autocomplete';
import {searchSchool} from '@util/helper';
import ManagerSmstPart from './manager-smst.part';
import TransDialog from "@components/TransDialog";
import ConfirmDialog from "@components/ConfirmDialog";
import {Link} from "react-router-dom";
import ManagerNoticePartView from "@pages/manager/manager-notice.part.view";
import useAlert from "@hooks/useAlert";
import {useParams, useNavigate} from "react-router-dom";
import { useLocation } from 'react-router-dom';
import ManagerSurveyPartMod from '@pages/manager/manager-survey.part.mod';
import ManagerSurveyPartPost from '@pages/manager/manager-survey.part.post';
import { hashids } from '@util/helper';
import SettingsIcon from '@mui/icons-material/Settings';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import ManagerSurveyPartStat from '@pages/manager/manager-survey.part.stat';
import AnalyticsOutlined  from '@mui/icons-material/AnalyticsOutlined';
import ManagerSurveyPartIndi from './manager-survey.part.indi'

const Boxs = styled(Box)`
  padding-bottom: 40px !important;
`;


const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;


const ManagerSurveyPage = () => {
  console.log('ManagerNoticePage rendering...')
  const inputRef = useRef(null)
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'
  const [detailScreen, set_detailScreen] = useState(false)
  const {more} = useParams()
  const navigate = useNavigate()

  const fields = [
    {field: 'id', placeholder: '아이디', type: 'text', value: -1, visible: more && (more === 'more'), canSrch: false, selList: []},
    {field: 'hashId', placeholder: '해쉬ID', type: 'text', value: -1, visible: true, canSrch: false, selList: []},
    {field: 'schoolId', placeholder: '학교ID', type: 'text', value: -1, visible: more && (more === 'more'), canSrch: false, selList: []},
    {field: 'googleFormId', placeholder: '구글폼ID', type: 'text', value: '', visible: more && (more === 'more'), canSrch: false, selList: []},
    {field: 'title', placeholder: '제목', type: 'text', value: '', visible: true, canSrch: false, selList: []},
    {field: 'modeCodeName', placeholder: '설문유형', type: 'text', value: '', visible: true, canSrch: false, selList: []},
    {field: 'content', placeholder: '내용', type: 'text', value: '', visible: false, canSrch: false, selList: []},
    {field: 'statCode', placeholder: '상태코드', type: 'text', value: '', visible: false, canSrch: false, selList: []},
    {field: 'userId', placeholder: '생성자ID', type: 'text', value: '', visible: false, canSrch: false, selList: []},
    {field: 'startTime', placeholder: '시작일시', type: 'text', value: '', visible: true, canSrch: false, selList: []},
    {field: 'endTime', placeholder: '종료일시', type: 'text', value: '', visible: true, canSrch: false, selList: []},
    {field: 'regTime', placeholder: '생성일시', type: 'text', value: '', visible: false, canSrch: false, selList: []},
    {field: 'uptTime', placeholder: '수정일시', type: 'text', value: '', visible: true, canSrch: false, selList: []},
  ]

  const visibleColumns = fields.filter(col => col.visible)
  const defRecord = {}
  fields.forEach(d => {
    defRecord[d.field] = d.value
  })


  defRecord.schoolList = []
  const defTerms = {}
  fields.filter(col => col.canSrch).map(d => d.field).forEach(d => defTerms[d] = '')
  const [dataList, set_dataList] = useState([])

  const [skipPageReset, setSkipPageReset] = React.useState(false)
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const dgHandler = useState(false)
  const [selIdx, set_selIdx] = useState(-1)
  const [pageNum, set_pageNum] = useState(0)
  const [pageSize, set_pageSize] = useState(10)
  const [totalCount, set_totalCount] = useState(0)
  const [pageInfo, set_pageInfo] = useState({pageNum: 0, pageSize: 10})
  const [terms, _set_terms] = useState(defTerms)
  const [fontSize, set_fontSize] = useState(12)
  const termsRef = useRef(terms)
  const [schoolGroup, set_schoolGroup] = useState([])
  const modHandler = useState(false)
  const viewHandler = useState(false)
  const postHandler = useState(false)
  const statHandler = useState(false)
  const [modOpen, set_modOpen] = useState(false)
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const modeCodes = codes.filter(r => r.codeGroupId === 'SA33')
  const schools = useSelector(state => state.schoolReducer)
  const account = useSelector(state => state.accountReducer)
  const schola = useSelector(state => state.scholaReducer)
  const {alert, renderAlert} = useAlert()
  const location = useLocation()
  const curLocationRef = useRef(location)
  const recordRef = useRef(defRecord)
  const set_terms = data => {
    termsRef.current = data
    _set_terms(data)
  }

  const onLoad = async () => {

    const info = await fetchSurveys()
    if(info) {
      const records = JSON.parse(info.records)
      for (const record of records) {
        record.hashId = hashids.encode(record.id)
        record.startTime1 = record.startTime
        record.startTime2 = moment(record.startTime, dateFormat).format('HH:mm:ss')

        record.endTime1 = record.endTime
        record.endTime2 = moment(record.endTime, dateFormat).format('HH:mm:ss')
        record.modeCode = record.modeCode ? record.modeCode : 'M000'
        record.modeCodeName = modeCodes.find(r => r.code === record.modeCode)?.name

        const filename = record.filename ?? ''
        const uname = record.imgUrl ? record.imgUrl.split('/').pop() : ''
        const path = uname ? record.imgUrl.substring(0, record.imgUrl.lastIndexOf('/')) : ''
        record.imgUrl = record.imgUrl ? `/scm/repo/${path}/${encodeURIComponent(uname)}` : no_image
        record.attchList = [{ id: +record.attchId, name: filename }]
      }
      const totalCount = info.totalCount

      set_dataList(records)
      set_totalCount(totalCount)
    }
  }

  const fetchSurveys = async () => {
    const url = `/survey/school/${schola.id}`
    openIndicator()
    const resp = await WebService.get(url, {
      pageNum: pageInfo.pageNum,
      pageSize: pageInfo.pageSize,
    })
    closeIndicator()

    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    return  JSON.parse(resp.repMessage)
  }

  const onDetail = async (id, guardianNum) => {
    set_detailScreen(true)
    modHandler[1](true)
  }

  const handleCopyUrl = async(id) => {
    const encoded = hashids.encode(id)
    const userToken = hashids.encode(0)
    try {
      const origin = window.location.origin
      await navigator.clipboard.writeText(`${origin}/public2/survey/${encoded}?userToken=${userToken}`);
      alert('클립보드에 링크가 복사되었습니다.');
    } catch (e) {
      alert('복사에 실패하였습니다');
    }
  }
  const onDelete = async (id) => {
    const url = `/survey/${id}/school/${schola.id}`
    const resp = await WebService.delete(url, {id: id})
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    onLoad()
    openSnackbar('삭제되었습니다.')

  }

  const onDeleteRepls = async (id) => {
    const url = `/survey/repls/${id}/school/${schola.id}`
    const resp = await WebService.delete(url, {id: id})
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    onLoad()
    openSnackbar('삭제되었습니다.')

  }

  const onChangeState = async (surveyId, statCode) => {
    const url = `/survey/${surveyId}/change/state/school/${schola.id}`
    openIndicator()
    const resp = await WebService.post(url, {}, {
      statCode: statCode
    })
    closeIndicator()

    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    onLoad()

    openSnackbar('변경되었습니다.')
  }

  const onCreate = () => {

    const now = moment().format(dateFormat)
    const newRecord = {
      ...defRecord,
      schoolId: schola.id,
      statCode: 'R000',
      modeCode: 'M000',
      smstId: -1,
      userId: account.user.id,
      startTime1: null,
      startTime2: '00:00:00',
      endTime1: null,
      endTime2: '23:59:59',
      uptTime: now,
      regTime: now,
    }
    recordRef.current = newRecord
    // set_detailScreen(true)
    modHandler[1](true)

  }

  const onSearch = () => {
    onLoad()
  }

  const onClear = () => {
    const obj = {}
    Object.keys(terms).forEach(k => {
      obj[k] = ''
    })
    set_terms(obj)
  }

  const handleChangePage = (event, newPage) => {
    set_pageInfo({...pageInfo, pageNum: newPage})
  }

  const handleChangeRowsPerPage = (event) => {

    const pageSize = parseInt(event.target.value, 10)
    set_pageInfo({pageNum: 0, pageSize: pageSize})
  }

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const {count, page, rowsPerPage, onPageChange} = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{flexShrink: 0, ml: 2.5}}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === 'rtl' ? <LastPageIcon/> : <FirstPageIcon/>}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowRight/> : <KeyboardArrowLeft/>}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft/> : <KeyboardArrowRight/>}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon/> : <LastPageIcon/>}
        </IconButton>
      </Box>
    );
  }


  useEffect(() => {
    if(curLocationRef.current.key !== location.key ) {
      curLocationRef.current = location
      set_pageInfo({ pageNum: 0, pageSize: 10 })
    }
  },[location])



  useEffect(() => {
    onLoad()
  }, [pageInfo])


  return (
    <div>
      {modHandler[0] ? (<ManagerSurveyPartMod record={recordRef.current} dialogHandler={modHandler} callback={onLoad}/>) : null}
      {viewHandler[0] ? (<ManagerNoticePartView record={recordRef.current} dialogHandler={viewHandler} callback={onLoad}/>) : null}
      {postHandler[0] ? (<ManagerSurveyPartPost record={recordRef.current} dialogHandler={postHandler} msgType="push" callback={onLoad}/>) : null}
      {statHandler[0] ? (<ManagerSurveyPartStat record={recordRef.current} dialogHandler={statHandler}  callback={onLoad}/>) : null}

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}>
        <div style={{ paddingRight: 10 }}>
          <h1>설문조사 관리 </h1>
        </div>
      </div>
      <div style={{display: "flex", flexDirection: "row"}}>
        <Button variant='outlined' color='primary' size='small' onClick={() => {
          onCreate()
        }}>
          생성
        </Button>
      </div>
      <div style={{paddingTop: 20}}>
        <MUITable>
          <MyTableHead>
            <TableRow>
              {
                fields.map((col, index) => {
                  if (col.visible) {
                    return (
                      <TableCell key={index} size='small'>
                        {col.placeholder}
                        {col.canSrch ?
                          (
                            <Fragment>
                              <br/>
                              <TextField label="" variant="outlined" size='small' inputProps={{
                                style: {
                                  fontSize: '0.875em',
                                  padding: 5,
                                  backgroundColor: '#fff'
                                }
                              }}
                              value={terms[col.field]}
                              onChange={(e) => {
                                const newTerms = {...terms}
                                newTerms[col.field] = e.target.value
                                set_terms(newTerms)
                              }}
                              />
                            </Fragment>
                          )
                          : (
                            <Fragment>
                            </Fragment>
                          )
                        }
                      </TableCell>
                    )
                  }
                })
              }
              <TableCell size='small' align={"center"}>
                게시
              </TableCell>
              <TableCell size='small' align={"center"}>
                관리
              </TableCell>
            </TableRow>
          </MyTableHead>
          <TableBody>
            {
              dataList.map((row, rowIdx) => (
                <TableRow key={rowIdx} onMouseEnter={() => {
                  recordRef.current = row
                }}>
                  {
                    fields.map((col, colIdx) => (
                      col.visible ? (
                        <Fragment>
                          {
                            col.field === 'title' ? (
                             // <TableCell style={{cursor: 'pointer'}} key={colIdx} onClick={() => { viewHandler[1](true) }}>
                              <TableCell key={colIdx} style={{cursor:'pointer'}} onClick={() => {
                                const url = `/public2/survey/${row.hashId}?userToken=${hashids.encode(account.user.id)}`
                                window.open(url, '_blank', 'noopener,noreferrer')
                                // navigate(`/public2/survey/${hashids.encode(row.id)}?userToken=${hashids.encode(account.user.id)}`)
                              }}>
                                <Typography variant='body2' fontWeight='bold'>
                                  {row[col.field]}
                                </Typography>
                              </TableCell>

                            ) : (
                              <TableCell key={colIdx}>
                                {row[col.field]}
                              </TableCell>
                            )
                          }
                        </Fragment>
                      ) : null
                    ))
                  }
                  <TableCell size='small' align='center'>
                    <Stack style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                      <Typography variant='body2'>Off</Typography>
                      <Switch
                        checked={row.statCode === 'R001'}
                        onChange={(e) => {
                          console.log(`v:${e.target.value} c:${e.target.checked}`)
                          const statCode = e.target.checked ? 'R001' : 'R002'
                          row.statCode = statCode

                          onChangeState(row.id, statCode)
                        }}
                      />

                      <Typography variant='body2'>On</Typography>
                    </Stack>

                  </TableCell>

                  <TableCell size='small' align='center'>
                    <FlatButton startIcon={<SettingsIcon />} style={{marginRight: 5}}
                      onClick={() => onDetail(row.id)}>설정</FlatButton>
                    <FlatButton startIcon={<SendOutlinedIcon />}
                      style={{marginRight: 5}} onClick={() => postHandler[1](true)}>알림</FlatButton>
                    <FlatButton startIcon={<AnalyticsOutlined />}
                      style={{marginRight: 5}} onClick={() => statHandler[1](true)}>분석</FlatButton>
                    {/* <FlatButton startIcon={<AnalyticsOutlined />}
                      style={{ marginRight: 5 }} onClick={() => handleCopyUrl(row.id)}>링크복사</FlatButton>*/}
                    <ConfirmDialog
                      btn={<FlatButton color='error'>삭제</FlatButton>}
                      title={'주의'}
                      content={'관련 설문조사의 응담 및 통계를 포함한 모둔 데이터가 삭제됩니다. 데이터를 삭제하시겠습니까?'}
                      bc={'error'}
                      perform={() => {
                        onDelete(row.id)
                      }}
                    />

                  </TableCell>
                </TableRow>
              ))
            }
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                sx={{
                  [`& .${tablePaginationClasses.spacer}`]: {
                    display: "none"
                  },
                  [`& .${tablePaginationClasses.toolbar}`]: {
                    justifyContent: "center"
                  }
                }}
                rowsPerPageOptions={[10, 20, {label: 'All', value: -1}]}
                colSpan={visibleColumns.length + 2}
                count={totalCount}
                rowsPerPage={pageInfo.pageSize}
                page={pageInfo.pageNum}
                SelectProps={{
                  inputProps: {
                    'aria-label': 'rows per page',
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
                labelDisplayedRows={
                  ({from, to, count}) => {
                    // return '' + from + '-' + to + ' 개 ' + count
                    return `${from} - ${to} of ${count}`
                  }
                }
                labelRowsPerPage={'페이지당 갯수'}
              />
            </TableRow>
          </TableFooter>
        </MUITable>

        {renderIndicator()}
        {renderAlert()}
      </div>
    </div>
  );

}

export default ManagerSurveyPage
